import { UpsertHuduAuthConfigInput } from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_HUDU_BASE_URL;

export const upsertHuduAuthConfig = async ({
  msp_name,
  hudu_url,
  hudu_api_key,
}: UpsertHuduAuthConfigInput) => {
  try {
    const url = `${BASE_URL}/api/msp/credentials`;
    const data = {
      msp_name,
      hudu_url,
      hudu_api_key,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getHuduAuthConfig = async () => {
  try {
    const url = `${BASE_URL}/api/msp/credentials`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateHuduStatus = async (status: boolean) => {
  try {
    const url = `${BASE_URL}/api/msp/status`;
    const data = {
      is_status: status,
    };
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const disconnectHudu = async () => {
  try {
    const url = `${BASE_URL}/api/disconnect-msp`;
    const response = await axiosClient.delete(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
